<template>
  <v-card flat tile>
    <v-row no-gutters class="mt-0">
      <v-col cols="6">
        <v-switch v-model="enablePage" label="page" class="mt-0 mb-2" color="grey darken-3" dense hide-details @change="togglePage" />
      </v-col>

      <v-col cols="6" v-if="enablePage">
        <v-switch
          v-model="value[getSelectedTab].page.setAutomatically"
          label="setAutomatically"
          class="mt-0 mb-2"
          color="grey darken-3"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="6" v-if="enablePage">
        <v-text-field v-model="value[getSelectedTab].page.page" label="page" class="mr-1 mb-2" color="grey darken-3" hide-details />
      </v-col>

      <v-col cols="6" v-if="enablePage">
        <v-select
          v-model="value[getSelectedTab].page.mode"
          :items="['list', 'form', 'new', 'search', 'sidebar']"
          class="ml-1 mb-2"
          color="grey darken-3"
          label="Value"
          append-icon="zmdi zmdi-chevron-down"
          hide-details
        />
      </v-col>

      <v-col cols="12" v-if="!enablePage">
        <v-text-field v-model="value[getSelectedTab].procedure.name" class="mt-4 mb-2" color="grey darken-3" label="Procedure" dense hide-details />
      </v-col>

      <v-col cols="6">
        <v-switch v-model="value[getSelectedTab].disabled" label="disabled" class="mt-1 mb-3" color="grey darken-3" dense hide-details />
      </v-col>

      <v-col cols="6">
        <v-switch v-model="value[getSelectedTab].reverseOrder" label="reverseOrder" class="mt-1 mb-3" color="grey darken-3" dense hide-details />
      </v-col>
    </v-row>

    <v-expansion-panels v-if="!enablePage" class="accordion-list-components" hover focusable>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3">Conditions Tab {{ getSelectedTab }}</span>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <devConditions :conditions="value[getSelectedTab].conditions" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],

  data: () => ({
    enablePage: false
  }),

  mounted() {
    'page' in this.value[this.getSelectedTab || 1] ? (this.enablePage = true) : (this.enablePage = false);
  },

  components: {
    devConditions: () => import('@/components/dev/dev-conditions')
  },

  computed: {
    getSelectedTab() {
      return parseInt(this.$store.getters['dev/getSelectedTab']) + 1;
    }
  },

  methods: {
    togglePage(e) {
      const page = {
        mode: '',
        page: '',
        setAutomatically: false
      };

      if (!e) delete this.value[this.getSelectedTab].page;

      if (e) {
        this.value[this.getSelectedTab].page = page;

        // --> Limpa (actions, fields e groups) ao utilizar page na tab!
        this.value[this.getSelectedTab].actions = {};
        this.value[this.getSelectedTab].fields = [];
        this.value[this.getSelectedTab].groups = [];
        this.value[this.getSelectedTab].conditions = {
          fields: [],
          hide: {
            actions: [],
            fields: []
          }
        };
      }
    }
  },

  watch: {
    getSelectedTab(newValue) {
      'page' in this.value[this.getSelectedTab || 1] ? (this.enablePage = true) : (this.enablePage = false);
    }
  }
};
</script>
